var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { useLang } from '../hooks/use-lang';
import { useComponentProps } from '../context/component-props-context';
import { classNames } from '@shapeable/utils';
var cls = classNames('ellipsis-button');
export var EllipsisButtonDefaultProps = {
  dotSize: 8,
  space: 1,
  colors: {
    border: 'strong',
    background: 'canvas',
    hover: {
      border: 'strong',
      background: 'appChrome'
    }
  }
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    min-height: 48px;\n    align-items: center;\n    cursor: pointer;\n    ", ";\n\n    ", ";\n    \n    border: none;\n    transition: opacity 0.3s;\n  "], ["\n    display: flex;\n    min-height: 48px;\n    align-items: center;\n    cursor: pointer;\n    ", ";\n\n    ", ";\n    \n    border: none;\n    transition: opacity 0.3s;\n  "])), theme.REMOVE_BUTTON_STYLE(), function (props) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.APPLY_COLORS({
      colors: props.colors,
      selector: cls.child('button')
    }));
  })
});
var DotStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 0;\n\n    ", "\n  "], ["\n    font-size: 0;\n\n    ", "\n  "])), function (props) {
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border-width: 1px;\n      border-style: solid;\n      width: ", "px;\n      height: ", "px;\n      margin-right: ", ";\n      border-radius: 50%;\n\n      &:last-child {\n        margin-right: 0;\n      }\n    "], ["\n      border-width: 1px;\n      border-style: solid;\n      width: ", "px;\n      height: ", "px;\n      margin-right: ", ";\n      border-radius: 50%;\n\n      &:last-child {\n        margin-right: 0;\n      }\n    "])), props.size, props.size, theme.UNIT(props.space));
  })
});
// -------- Components -------->
var My = {
  NAME: 'EllipsisButton',
  Container: styled.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Dot: styled.span.attrs(cls.attr('button'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), DotStyles)
};
export var EllipsisButton = React.forwardRef(function (props, ref) {
  var _a = useComponentProps(My.NAME, props, EllipsisButtonDefaultProps),
    className = _a.className,
    dotSize = _a.dotSize,
    colors = _a.colors,
    space = _a.space;
  var t = useLang();
  var title = props.title && t(props.title);
  var dotProps = {
    size: dotSize,
    space: space
  };
  var swallowMousedown = function (event) {
    event.stopPropagation();
  };
  var handleClick = function (event) {
    event.stopPropagation();
    event.preventDefault();
    if (props.onClick) {
      props.onClick(event);
    }
  };
  return React.createElement(My.Container, {
    colors: colors,
    ref: ref,
    type: "button",
    title: title,
    onMouseDown: swallowMousedown,
    onClick: handleClick,
    className: "".concat(className, " ellipsis-button")
  }, React.createElement(My.Dot, __assign({}, dotProps)), React.createElement(My.Dot, __assign({}, dotProps)), React.createElement(My.Dot, __assign({}, dotProps, {
    isLast: true
  })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;